<template>
    <div class="panel-body" id="station-detail">
        <div class="panel-nav">
            <button class="close-button" v-on:click.prevent="closePanel"></button>
        </div>
        <div class="scroller padded" v-if="station">
            <h2>{{ station.codice }} - {{ station.comune }}</h2>
            <p class="subtitle">({{ station.indirizzo }})</p>

            <div class="prize-row" v-if="station.fuel">
                <table>
                    <tr v-if="station.chiuso != 1">
                        <td :class="'fuel-type ' + station.fuel.nomecarburante">{{ station.fuel.nomecarburante }}</td>
                        <td class="arrow"><div :class="station.fuel.nomecarburante"></div></td>
                        <td class="fuel-price" v-if="!editing">{{ station.fuel.costo }}{{ station.fuel.valuta }}</td>
                        <td class="fuel-price" v-if="editing"><input v-model="station.fuel.costo" type="text" required />{{ station.fuel.valuta }}</td>
                        <td class="separator" v-if="capabilities.segnala_prezzo"></td>
                        <td class="fuel-submission" v-if="!editing && capabilities.segnala_prezzo && station.selfservice != 1" @click="station.fuel.costo='', editing=true">Segnala prezzo</td>
                        <td class="fuel-submission" v-if="capabilities.segnala_prezzo && station.selfservice == 1"></td>
                        <td class="fuel-submission" v-if="editing && station.selfservice != 1" v-on:click="submitPrice()">Invia</td>
                    </tr>
                    <tr v-if="station.selfservice == 1">
                        <td :class="'fuel-type ' + station.fuel.nomecarburante">{{ station.fuel.nomecarburante }}<div class="self">Self-service</div></td>
                        <td class="arrow"><div :class="station.fuel.nomecarburante"></div></td>
                        <td class="fuel-price" v-if="!editing">{{ station.fuelself.costo }}{{ station.fuelself.valuta }}</td>
                        <td class="fuel-price" v-if="editing"><input v-model="station.fuelself.costo" type="text" required />{{ station.fuelself.valuta }}</td>
                        <td class="separator" v-if="capabilities.segnala_prezzo"></td>
                        <td class="fuel-submission" v-if="!editing && capabilities.segnala_prezzo" @click="station.fuelself.costo='', station.fuel.costo='', editing=true">Segnala prezzo</td>
                        <td class="fuel-submission" v-if="editing" v-on:click="submitPrice()">Invia</td>
                    </tr>
                    <tr v-if="station.chiuso == 1">
                        <td :class="'fuel-type ' + station.fuel.nomecarburante">{{ station.fuel.nomecarburante }}</td>
                        <td class="arrow"><div :class="station.fuel.nomecarburante"></div></td>
                        <td class="fuel-price">Chiuso</td>
                    </tr>
                </table>
            </div>
            <div class="price-update" v-if="station.fuel && station.fuel.datarilevamento">(aggiornato al {{ [ station.fuel.datarilevamento, "YYYYMMDDTHH:mm:ss" ] | moment("DD/MM/YYYY HH:mm") }})</div>

            <Adsense v-if="showADS && capabilities.googlead.client"
                    :data-ad-client="capabilities.googlead.client"
                    :data-ad-slot="capabilities.googlead.slot">
            </Adsense>

            <h3 class="details">Dettagli</h3>

            <div class="nonpubblico gray-box" v-if="station.nonpubblico == 1">
                <span class="green-title">Istruzioni accesso:</span>
                <span class="value">{{ station.istruzioniaccesso }}</span>
            </div>

            <div class="phone-number gray-box" v-if="station.telefono">
                <span class="green-title">Telefono:</span>
                <span class="value">{{ station.telefono }}</span>
            </div>

            <div class="hours gray-box" v-if="station.orari_solare || station.orari_legale">
                <ul class="solare" v-if="station.orari_solare">
                    <li><span class="green-title">Orario ora Solare</span></li>
                    <li v-if="station.orari_solare.feriale">Feriale: {{ station.orari_solare.feriale.apertura_mattutina.ora }} <span v-if="station.orari_solare.feriale.chiusura_mattutina">{{ station.orari_solare.feriale.chiusura_mattutina.ora }} - {{ station.orari_solare.feriale.apertura_pomeridiana.ora }} </span>{{ station.orari_solare.feriale.chiusura_pomeridiana.ora }}</li>
                    <li v-if="station.orari_solare.prefestivo">Prefestivo: {{ station.orari_solare.prefestivo.apertura_mattutina.ora }} <span v-if="station.orari_solare.prefestivo.chiusura_mattutina">{{ station.orari_solare.prefestivo.chiusura_mattutina.ora }} - {{ station.orari_solare.prefestivo.apertura_pomeridiana.ora }} </span>{{ station.orari_solare.prefestivo.chiusura_pomeridiana.ora }}</li>
                    <li v-if="station.orari_solare.festivo">Festivo: {{ station.orari_solare.festivo.apertura_mattutina.ora }} <span v-if="station.orari_solare.festivo.chiusura_mattutina">{{ station.orari_solare.festivo.chiusura_mattutina.ora }} - {{ station.orari_solare.festivo.apertura_pomeridiana.ora }} </span>{{ station.orari_solare.festivo.chiusura_pomeridiana.ora }}</li>
                </ul>
                <ul class="legale" v-if="station.orari_legale">
                    <li><span class="green-title">Orario ora Legale</span></li>
                    <li v-if="station.orari_legale.feriale">Feriale: {{ station.orari_legale.feriale.apertura_mattutina.ora }} <span v-if="station.orari_legale.feriale.chiusura_mattutina">{{ station.orari_legale.feriale.chiusura_mattutina.ora }} - {{ station.orari_legale.feriale.apertura_pomeridiana.ora }} </span>{{ station.orari_legale.feriale.chiusura_pomeridiana.ora }}</li>
                    <li v-if="station.orari_legale.prefestivo">Prefestivo: {{ station.orari_legale.prefestivo.apertura_mattutina.ora }} <span v-if="station.orari_legale.prefestivo.chiusura_mattutina">{{ station.orari_legale.prefestivo.chiusura_mattutina.ora }} - {{ station.orari_legale.prefestivo.apertura_pomeridiana.ora }} </span>{{ station.orari_legale.prefestivo.chiusura_pomeridiana.ora }}</li>
                    <li v-if="station.orari_legale.festivo">Festivo: {{ station.orari_legale.festivo.apertura_mattutina.ora }} <span v-if="station.orari_legale.festivo.chiusura_mattutina">{{ station.orari_legale.festivo.chiusura_mattutina.ora }} - {{ station.orari_legale.festivo.apertura_pomeridiana.ora }} </span>{{ station.orari_legale.festivo.chiusura_pomeridiana.ora }}</li>
                </ul>
            </div>

            <div class="notes gray-box" v-if="station.note_orario">
                <span class="green-title">Note:</span>
                <span class="value">{{ station.note_orario }}</span>
            </div>

        </div>
    </div>
</template>

<script>

    import { serverBus } from '../main';
    import Api from "../api";

    export default {
        methods: {
            closePanel() {
                serverBus.$emit("closePanel");
            },
            submitPrice() {
                var $scope = this;

                Api.postPrice(this.station_id,this.station.fuel.costo,this.station.fuelself.costo,this.fuel,function(err,res){
                    if(err) {
                        $scope.$swal({
                            title: "Segnalazione non inviata",
                            text: err,
                            icon: "error",
                            button: "Ok",
                        })
                    } else {
                        $scope.$swal({
                            title: "Segnalazione inviata",
                            text: "Grazie della segnalazione, un amministratore provvederà a inserirla quanto prima!",
                            icon: "success",
                            button: "Ok",
                        })
                        serverBus.$emit("closePanel");
                    }
                });

                this.editing = false;
            },
            loadData(_station) {
                this.showADS = false;
                if(!_station) _station = this.$parent.$parent.$parent.$parent.distID;
                this.station_id = _station.id;
                this.fuel = this.$parent.$parent.$parent.$parent.fuel;

                var $scope = this;

                if(typeof $scope.station_id == 'undefined') {
                    serverBus.$emit("closePanel");
                } else {
                    Api.getStation(this.station_id, this.fuel, function (err, res) {
                        $scope.station = res;
                        $scope.showADS = true;

                        if (res.prezzi) {
                            for (var i = 0; i < res.prezzi.length; i++) {
                                if ($scope.fuel == 8) {
                                  if (res.prezzi[i].idcarburante == 8) {
                                    $scope.station.fuelself = res.prezzi[i];
                                  }
                                  if (res.prezzi[i].idcarburante == 1) {
                                    $scope.station.fuel = res.prezzi[i];
                                  }
                                }else {
                                  if (res.prezzi[i].idcarburante == 8 && $scope.fuel == 1) {
                                    $scope.station.fuelself = res.prezzi[i];
                                  }
                                  if (res.prezzi[i].idcarburante == $scope.fuel) {
                                    $scope.station.fuel = res.prezzi[i];
                                  }
                                }
                            }
                        }

                        if (!$scope.station.fuel) {
                            $scope.station.fuel = {
                                nomecarburante: (($scope.fuel == 1) ? 'Metano' : ($scope.fuel == 8) ? 'Metano Self-Service' : ($scope.fuel == 4) ? 'GPL' : ($scope.fuel == 7) ? 'LPG' : 'Elettriche'),
                                valuta: res.valuta,
                                costo: '-- '
                            }
                        }

                        setTimeout(function(){
                            var stationDetail = document.getElementById('station-detail');
                            if (stationDetail){
                              stationDetail.style = "";
                            }
                        },1000);

                    });
                }
            }
        },
        data() {
            return {
                showADS: false,
                station_id: null,
                fuel: null,
                fuelself: null,
                station: null,
                editing: false,
                capabilities: false
            };
        },
        created() {
            this.capabilities = this.$parent.$parent.$parent.$parent.capabilities;

            serverBus.$on('distChanged',this.loadData);
            serverBus.$on('fuelChanged',function(fuel){
              serverBus.$emit("closePanel");
            });

            serverBus.$emit('pageChanged',{page:'MapDetail'});
            this.loadData(false);
        }
    }

</script>
<style scoped lang="scss">
    #station-detail {
        h2 {
            font-family: Merriweather;
            margin-bottom: 0px;
        }
        p.subtitle {
            margin: 0px;
            font-size: 14px;
            color: #666666;
        }
        h3.details {
            font-size: 16px;
            font-weight: bold;
            text-transform: uppercase;
            color: #525252;
            margin: 40px 0px 0px;
            padding: 0px 0px 5px 0px;
            border-bottom: 1px solid #ccc;
        }
        .prize-row {
            margin-top: 50px;
            line-height: 60px;
            table, tr, td {
                margin: 0px;
                padding: 0px;
                border: none;
                border-spacing: 0px;
            }
            tr {
                background-color: #f3f3f3;
            }
            td {
                height: 30px;
                &.fuel-type {
                    text-transform: uppercase;
                    line-height: 85%;
                    text-align: center;
                    font-size: 12px;
                    font-weight: bold;
                    color: white;
                    padding: 0px 20px;
                    &.Autostradale {
                        background-color: rgb(66, 166, 42);
                    }
                    &.Metano {
                        background-color: rgb(14, 113, 180);
                    }
                    &.LPG {
                        background-color: rgb(67, 62, 142);
                    }
                    &.Elettriche {
                        background-color: rgb(255, 221, 15);
                        color: black;
                    }
                    &.GPL {
                        background-color: rgb(220, 0, 44);
                    }
                    div{
                        &.self{
                            font-size: 9px;
                            white-space: nowrap;
                        }
                    }
                }
                &.fuel-price {
                    width: 100%;
                    font-weight: bold;
                    font-size: 18px;
                    padding-left: 30px;
                    white-space: nowrap;
                    input[type=text] {
                        font-size: 14px;
                        padding: 10px;
                        margin-right: 10px;
                        width: 50%;
                    }
                }
                &.fuel-submission {
                    line-height: 14px;
                    font-size: 12px;
                    text-transform: uppercase;
                    font-weight: bold;
                    padding-right: 20px;
                    cursor: pointer;
                }
                &.separator {
                    background-color: #cccccc;
                    width: 1px;
                    margin: 15px 20px 15px 20px;
                    display: block;
                }
                &.arrow {
                    div {
                        width: 0;
                        height: 0;
                        border-top: 8px solid transparent;
                        border-bottom: 8px solid transparent;
                        &.Autostradale {
                            border-left: 8px solid rgb(66, 166, 42);
                        }
                        &.Metano {
                            border-left: 8px solid rgb(14, 113, 180);
                        }
                        &.LPG {
                            border-left: 8px solid rgb(67, 62, 142);
                        }
                        &.Elettriche {
                            border-left: 8px solid rgb(255, 221, 15);
                        }
                        &.GPL {
                            border-left: 8px solid rgb(220, 0, 44);
                        }
                    }
                }
            }
        }
        .price-update {
            margin-top: 15px;
            font-size: 12px;
            color: #666;
        }
        .gray-box {
            margin-top: 10px;
            background-color: #f3f3f3;
            background-repeat: no-repeat;
            padding: 20px 20px 20px 100px;
            font-size: 14px;
            .green-title {
                font-weight: bold;
                color: #41a52a;
                margin-right: 5px;
            }
            ul {
                list-style: none;
                padding: 0px;
                margin: 0px;
            }
            &.phone-number {
                background-position: 40px 20px;
                background-image: url('../assets/details-phone.png');
            }
            &.nonpubblico {
                background-position: 40px 20px;
                background-image: url('../assets/details-lock.png');
            }
            &.hours {
                background-position: 40px 25px;
                background-image: url('../assets/details-hours.png');
            }
            &.notes {
                background-position: 40px 20px;
                background-image: url('../assets/details-note.png');
            }
        }
    }
</style>
